import React from "react";
import TimePeriodLabel from "../../Misc/TimePeriodLabel";
export default class TimesheetTable extends React.Component {
  render() {
    const { datesData = {}, readOnly } = this.props;
    const { dates = [], clients = {}, schedules = {} } = datesData;

    return (
      <div className="table-responsive">
        <table className={`table timesheet-table ${!readOnly && "enabled"}`}>
          <thead>
            <tr>
              <td width="1">
                <div className="nowrap" style={{ width: "300px" }}>
                  {this.props.onStaffAdd && !readOnly && (
                    <i
                      title="Добавить строку"
                      onClick={() => this.props.onStaffAdd()}
                      className="fa fa-plus cursor-pointer text-hover-primary mr-2"
                    ></i>
                  )}
                  Сотрудник
                </div>
              </td>
              {dates.map((date, idx) => {
                return (
                  <td className="nowrap" key={idx}>
                    {date}
                  </td>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {Object.entries(clients).map(([clientId, client], idx) => {
              return (
                <tr key={idx}>
                  <td>
                    <div className="nowrap" style={{ width: "300px" }}>
                      {this.props.onStaffRemove && !readOnly && (
                        <i
                          title="Удалить строку"
                          onClick={() =>
                            this.props.onStaffRemove(clientId, client)
                          }
                          className="fa fa-times cursor-pointer text-hover-danger mr-2"
                        ></i>
                      )}
                      {client.fullname}
                      <div className="text-muted small">
                        {client.positionname}
                      </div>
                    </div>
                  </td>
                  {dates.map((date, idx) => {
                    let clientSchedule = schedules[clientId] || {};
                    let schedule = clientSchedule[date] || [];
                    return (
                      <td key={idx}>
                        {schedule.map((scheduleItem, idx) => (
                          <TimePeriodLabel
                            onRemove={() =>
                              this.props.onScheduleRemove({
                                clientId,
                                date,
                                idx,
                              })
                            }
                            onChange={(period) =>
                              this.props.onScheduleChange({
                                clientId,
                                date,
                                idx,
                                period,
                              })
                            }
                            readOnly={readOnly}
                            from={scheduleItem[0]}
                            to={scheduleItem[1]}
                            key={idx}
                            className="mb-2"
                          />
                        ))}

                        {!readOnly && (
                          <div
                            className="time-period-label open text-center bg-white"
                            onClick={() =>
                              this.props.onScheduleAdd({
                                clientId,
                                date,
                              })
                            }
                          >
                            Добавить
                            <i className="fa fa-plus ml-2"></i>
                          </div>
                        )}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}
